<template>
  <div class="content-container">
    <div class="table-wrapper">
      <div class="opration-wrapper">
        <span>{{ $t('message.workRecycleNotice') }}</span>
        <div style="float: right;">
          <a-popconfirm placement="top" :ok-text="$t('actionTitles.yes')" :cancel-text="$t('actionTitles.no')"
            @confirm="batchRegain">
            <template slot="title">
              {{ $t('message.batchRegainHint') }}
            </template>
            <a-button type="primary">{{ $t(`actionTitles.resume`) }}</a-button>
          </a-popconfirm>
          <a-popconfirm placement="top" :ok-text="$t('actionTitles.yes')" :cancel-text="$t('actionTitles.no')"
            @confirm="bacthDelete">
            <template slot="title">
              {{ $t('message.batchDeleteHint') }}
            </template>
            <a-button style="color: red; margin-left: 10px">{{ $t(`actionTitles.delete`) }}</a-button>
          </a-popconfirm>
        </div>
      </div>
      <clear-selected alert-type="error" :show="selectedRowKeys.length > 0" :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected" />

      <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :data-source="pageResult.data" :loading="loading" rowKey="id" :pagination="pagination"
        @change="handleTableChange">
        <a-table-column key="name" :title="$t('table.common.thead.name')" data-index="name">
          <template slot-scope="text, record">
            <a-row type="flex" align="middle">
              <div class="imgMerge" v-if="workType === 3">
                <img src="@/assets/img/3Dicon.png" class="icon3D">
                <img :src="record.thumb_path" alt style="width:40px;margin-right:10px;" />
              </div>
              <img v-else :src="record.thumb_path" alt style="width: 40px; margin-right: 10px;" />
              <div>
                <span>{{ record.name }}</span>
                <br />
                <span>{{ record.regoin_name }}</span>
              </div>
            </a-row>
          </template>
        </a-table-column>
        <a-table-column key="readCount" :title="$t('table.work.thead.readCount')" data-index="total_browse">
          <template slot-scope="text, record">
            {{ record.total_browse != undefined ? record.total_browse : "-" }}
          </template>
        </a-table-column>
        <a-table-column key="state" :title="$t('table.common.thead.state')" data-index="is_public">
          <template slot-scope="text, record">
            {{ record.is_public != undefined ? $t(`enum.workIsPublic.${record.is_public}`) : "-" }}
          </template>
        </a-table-column>
        <a-table-column key="updateTime" :title="$t('table.common.thead.updateTime')" data-index="create_time" />
        <a-table-column key="operate" :title="$t('table.common.thead.operate')">
          <template slot-scope="text, record">
            <span>
              <a-popconfirm placement="top" :ok-text="$t('actionTitles.yes')" :cancel-text="$t('actionTitles.no')"
                @confirm="handleRegain(record.id)">
                <template slot="title">
                  {{ $t('message.regainHint') }}
                </template>
                <a>{{ $t('actionTitles.resume') }}</a>
              </a-popconfirm>
              <a-divider type="vertical" />
              <!-- 刪除確認框-->
              <a-popconfirm placement="top" :ok-text="$t('actionTitles.yes')" :cancel-text="$t('actionTitles.no')"
                @confirm="handleDelete(record.id)">
                <template slot="title">
                  {{ $t('message.deleteHint') }}
                </template>
                <a style="color: red">{{ $t('actionTitles.delete') }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import { queryRecycle, workDelete, workRegain } from "@/api/work";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
      },
      expand: false,
      selectedRowKeys: [],
      workList: [],
      searchForm: {
        pid: 0
      },
      pageResult: {},
      loading: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      workType: 1,
    };
  },
  components: { ClearSelected },
  computed: {
    ...mapGetters(["userInfo"]),
    count() {
      return this.expand ? 11 : 7;
    },
  },
  mounted() {
    this.loadData();
    console.log("Current workType:", this.workType);

  },
  updated() {
    // console.log("updated");
  },
  methods: {
    loadData() {
      this.loading = true;
      this.searchParam = {
        work_type: this.workType,
        ...{ current_page: this.pagination.current, per_page: this.pagination.pageSize },
      }
      queryRecycle(this.searchParam)
        .then((ret) => {
          this.loading = false;
          this.pageResult = ret.data;
          this.pagination.total = ret.data.total;
          this.selectedRowKeys = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDelete(id) {
      workDelete({ "id": id }).then(res => {
        this.loadData();
        this.$message.success(this.$i18n.t('message.deleteSuccess'));
      })
    },
    handleRegain(id) {
      workRegain({ "id": id }).then(res => {
        this.loadData();
        this.$message.success(this.$i18n.t('message.regainSuccess'));
      })
    },
    bacthDelete() {
      if (this.selectedRowKeys.length > 0) {
        workDelete({ "id": this.selectedRowKeys }).then(res => {
          this.loadData();
          this.$message.success(this.$i18n.t('message.deleteSuccess'));
        })
      } else {
        this.$message.warning(this.$i18n.t("message.selectHint"));
      }
    },
    batchRegain() {
      if (this.selectedRowKeys.length > 0) {
        workRegain({ "id": this.selectedRowKeys }).then(res => {
          this.loadData();
          this.$message.success(this.$i18n.t('message.regainSuccess'));
        })
      } else {
        this.$message.warning(this.$i18n.t("message.selectHint"));
      }
    },
    handleReset() {
      this.form.resetFields();
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.loadData();
    },
  },
};
</script>

<style lang="less" scoped>
.imgMerge {
  position: relative;
}

.icon3D {
  width: 40%;
  height: auto;
  position: absolute;
  top: -7px;
  left: -7px;
}
.resumeBtn{
  background-color: #7101ad;
  border-color: #7101ad;
}
</style>
